import { FC } from 'react';

type StatCardProps = {
  label: string;
  value: React.ReactNode;
};

export const RosterDrawerStatCard: FC<StatCardProps> = ({ label, value }) => (
  <div className="border-2 rounded-md p-2 w-60">
    <span className="font-semibold">{label}</span>
    <div>{value}</div>
  </div>
);
